import {Component, ViewChild} from '@angular/core';
import {Content, IonicPage, Loading, LoadingController, NavController} from 'ionic-angular';

// @reference https://github.com/ackerapple/ack-angular-webcam
// Imported here just for type checking. Optional.
import {WebCamComponent} from 'ack-angular-webcam';

import { ProofBeforeBeginPage } from '../proof-before-begin/proof-before-begin';
import { UpdateTitleDocumentPage } from '../update-title-document/update-title-document';

import {AlertProvider} from '../../providers/alert/alert';
import {MediaProvider} from '../../providers/media/media';
import {ProofServerProvider} from '../../providers/proof-server/proof-server';
import {ProofProvider} from '../../providers/proof/proof';
import {DateTimeProvider} from '../../providers/datetime/datetime';

import {MediaItem} from '../../models/mediaitem';

import {Geolocation} from '@ionic-native/geolocation';
import {NativeGeocoder} from '@ionic-native/native-geocoder';

import {HttpClient} from '@angular/common/http';
import {ProofAudioProvider} from '../../providers/proof-audio/proof-audio';
import {DomSanitizer} from '@angular/platform-browser';

/**
 * Generated class for the IdentificationCheckOnAppPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-identification-check-on-web',
  templateUrl: 'identification-check-on-web.html',
})
export class IdentificationCheckOnWebPage {

  @ViewChild(Content) content: Content;

  loader: Loading;
  detectingWebcam: boolean = true;
  hasWebcam: boolean = true;
  isWebcamRequired: boolean = false;
  // Will be populated by <ack-webcam [(ref)]="webcam">
  selfieColor: string = 'danger';
  selfieWebcam: WebCamComponent;
  selfieBase64: string;
  frontIdentificationColor: string = 'danger';
  frontIdentificationWebcam: WebCamComponent;
  frontIdentificationBase64: string;
  backIdentificationColor: string = 'danger';
  backIdentificationWebcam: WebCamComponent;
  backIdentificationBase64: string;

  fileDocument: any;
  fileSelfie: any;

  fileDocumentUpload: File = null;
  fileSelfieUpload: File = null;

  // Identification Question
  answer: string;
  question: any;
  questionIdx: number;
  questionsTotal: number;
  wrongAnswerTotal: number;

  userLocation;
  userIp;

  // Audio Record
  isRecording = false;
  recordedTime;
  blobUrl;

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private alertProvider: AlertProvider,
    private mediaProvider: MediaProvider,
    private proofServerProvider: ProofServerProvider,
    private proofProvider: ProofProvider,
    private dateTimeProvider: DateTimeProvider,
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    private http: HttpClient,
    private proofAudioProvider: ProofAudioProvider,
    private sanitizer: DomSanitizer,
  ) {
    this.question = proofProvider.getCurrentIdentificationQuestion();
    this.questionIdx = proofProvider.getCurrentIdentificationQuestionIdx();
    this.questionsTotal = proofProvider.getIdentificationQuestionsTotal();
    this.wrongAnswerTotal = 0;
    this.fileDocument = null;
    this.fileSelfie = null;
    this.isWebcamRequired = proofProvider.isWebcamRequired();

    /**
     * Audio Record
     */
    this.proofAudioProvider.recordingFailed().subscribe(() => {
      this.isRecording = false;
    });

    this.proofAudioProvider.getRecordedTime().subscribe((time) => {
      this.recordedTime = time;
    });

    this.proofAudioProvider.getRecordedBlob().subscribe((data) => {
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IdentificationCheckOnWebPage');
    const that = this;

    this.loader = this.loadingCtrl.create({
      content: 'Verificando se existe webcam e sua permissão de acesso...'
    });
    this.loader.present();

    this.detectWebcam((hasWebcam: boolean) => {
      console.log('Webcam: ' + ((hasWebcam) ? 'yes' : 'no'));
      that.hasWebcam = hasWebcam;
      that.detectingWebcam = false;
      that.loader.dismiss();
    });

    this.startRecording();
  }

  goBack() {
    if ((!this.hasWebcam) && (this.isWebcamRequired)) {
      this.navCtrl.pop();
    }
  }

  public doContinue(): void {
    if (this.hasWebcam) {
      let valid: boolean = true;
      valid = (valid) && (this.selfieColor !== 'danger');
      valid = (valid) && (this.frontIdentificationColor !== 'danger');
      valid = (valid) && (this.backIdentificationColor !== 'danger');

      if (valid) {
        this.proofServerProvider.sendMedias(this.proofProvider.getId());
        this.navCtrl.push(UpdateTitleDocumentPage, {
          buttonContinue: true,
          animation: 'ios-transition'
        });

      } else {
        this.alertProvider.doAlert('Existem informações a serem fornecidas.');
      }
    }
  }

  onCamError(err) {
    let that = this;
    console.log(err);

    if (this.hasWebcam) {
      this.hasWebcam = false;
    }

    this.content.scrollToTop();

    // Unlock proof on server
    this.proofServerProvider.unlock(this.proofProvider.getId()).subscribe({
      next: x => {
        console.log('Observer got a next value: ' + x);
        that.loader.dismiss();
      },
      error: err => {
        console.log('Observer got an error: ' + err);
        that.loader.dismiss();
      },
      complete: () => {
        console.log('Observer got a complete notification');
        that.loader.dismiss();
      },
    });
  }

  onCamSuccess() {
    this.loader.dismiss();
  }

  takeSelfie() {
    if ((this.hasWebcam) && (this.selfieColor === 'danger')) {
      let that = this;

      this.mediaProvider.takeWebcamPicture(this.selfieWebcam, (data: string) => {
        that.selfieColor = 'primary';
        that.selfieBase64 = data;

        let item = new MediaItem();
        item.captured = this.dateTimeProvider.getISOString();
        item.kind = 'PS';
        item.contentOrPath = data;
        that.mediaProvider.addMedia(item);
      });
    }
  }

  takeSelfieAgain() {
    if (this.selfieColor === 'primary') {
      this.selfieColor = 'danger';
    }
  }

  takeFrontIdentification() {
    if ((this.hasWebcam) && (this.frontIdentificationColor === 'danger')) {
      let that = this;

      this.mediaProvider.takeWebcamPicture(this.frontIdentificationWebcam, (data: string) => {
        that.frontIdentificationColor = 'primary';
        that.frontIdentificationBase64 = data;

        let item = new MediaItem();
        item.captured = this.dateTimeProvider.getISOString();
        item.kind = 'PF';
        item.contentOrPath = data;
        that.mediaProvider.addMedia(item);
      });
    }
  }

  takeFrontIdentificationAgain() {
    if (this.frontIdentificationColor === 'primary') {
      this.frontIdentificationColor = 'danger';
    }
  }

  takeBackIdentification() {
    if ((this.hasWebcam) && (this.backIdentificationColor === 'danger')) {
      let that = this;

      this.mediaProvider.takeWebcamPicture(this.backIdentificationWebcam, (data: string) => {
        that.backIdentificationColor = 'primary';
        that.backIdentificationBase64 = data;

        let item = new MediaItem();
        item.captured = this.dateTimeProvider.getISOString();
        item.kind = 'PB';
        item.contentOrPath = data;
        that.mediaProvider.addMedia(item);
      });
    }
  }

  takeBackIdentificationAgain() {
    if (this.backIdentificationColor === 'primary') {
      this.backIdentificationColor = 'danger';
    }
  }

  /**
   * Answer the identification question.
   * Warning: Used when camera not exists or is not enabled.
   */
  doAnswer() {
    let that = this;

    this.proofProvider.addIdentificationAnswer(this.question.id, this.answer, () => {
      // Verify if it is a right question
      let rightAnswer = (that.question.answer === parseInt(that.answer, 10));
      if (!rightAnswer) {
        that.wrongAnswerTotal++;
      }

      let nextQuestion = that.proofProvider.getNextIdentificationQuestion();
      if (nextQuestion !== null) {
        that.answer = null;
        that.question = nextQuestion;
        that.questionIdx = that.proofProvider.getCurrentIdentificationQuestionIdx();
        that.questionsTotal = that.proofProvider.getIdentificationQuestionsTotal();
      } else if (that.wrongAnswerTotal >= 2) {
        // Notify that answered the identification wrong
        that.loader = that.loadingCtrl.create({
          content: 'Aguarde...'
        });
        that.loader.present();

        setTimeout(() => {
          that.proofServerProvider.send(that.proofProvider.getId(), null, (sendingStatus: any) => {
            window.location.reload(true);
          });
        }, 1000);
      } else {
        // Continue to proof
        that.navCtrl.push(ProofBeforeBeginPage);
      }
    });
  }

  /**
   * Audio Record Section
   */
  startRecording() {
    if (!this.isRecording) {
      this.isRecording = true;
      this.proofAudioProvider.startRecording();

      setTimeout(() => {
        this.stopRecording()

      }, 10000);
    }
  }

  abortRecording() {
    if (this.isRecording) {
      this.isRecording = false;
      this.proofAudioProvider.abortRecording();
    }
  }

  stopRecording() {
    if (this.isRecording) {
      let questionId = null;
      let kind = 'PA';
      let note = null;
      let extra = null;
      let captured = this.dateTimeProvider.getISOString();
      let seconds = null;
      let secondsRemaining = null;
      this.proofAudioProvider.stopRecording(questionId, kind, note, extra, captured, seconds, secondsRemaining);
      this.isRecording = false;
    }
  }

  clearRecordedData() {
    this.blobUrl = null;
  }

  ngOnDestroy(): void {
    this.abortRecording();
  }

  private detectWebcam(callback: any) {
    let md = navigator.mediaDevices;

    if ((!md) || (!md.enumerateDevices)) {
      return callback(false);
    }

    md.enumerateDevices().then((devices: any) => {
      callback(devices.some((device: any) => ('videoinput' === device.kind)));
    })
  }

  fileChange(event, target) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      if (target === 'document') {
        reader.onload = (event: any) => {
          this.fileDocument = event.target.result;
        }
        this.fileDocumentUpload = event.target.files[0];

        reader.readAsDataURL(event.target.files[0]);  // to trigger onload
        let fileList: FileList = event.target.files;
        let file: File = fileList[0];
      } else if (target === 'selfie') {
        reader.onload = (event: any) => {
          this.fileSelfie = event.target.result;
        }
        this.fileSelfieUpload = event.target.files[0];

        reader.readAsDataURL(event.target.files[0]);  // to trigger onload
        let fileList: FileList = event.target.files;
        let file: File = fileList[0];
      }
    }
  }

  sendFiles() {
    let that = this;

    if (that.fileDocument === null) {
      this.alertProvider.doAlert('Envie uma foto de um documento que contenha foto e CPF.');
    } else if (that.fileSelfie === null) {
      this.alertProvider.doAlert('Envie uma foto, ao estilo Selfie, sua.');
    } else {
      this.proofServerProvider.sendFile(this.proofProvider.getId(), 'PF', that.fileDocumentUpload);
      this.proofServerProvider.sendFile(this.proofProvider.getId(), 'PS', that.fileSelfieUpload);

      that.navCtrl.push(ProofBeforeBeginPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/identification-check-on-web/identification-check-on-web.ts